<template>
    <div class="">
        <install-wizard-card>
            <template #top-header>
                Connectivity
            </template>
            <template #top-content>
                Don't install those devices quite yet! Let's test their connectivity before putting them into hard-to-reach places.
            </template>

            <template #body-summary>
                <div class="w-full md:w-1/3">
                    <floating-input
                            id="search"
                            label="Search By Serial Number"
                            v-model:value="search"
                    ></floating-input>
                </div>
            </template>

            <template #body-action>
                <div class="overflow-hidden bg-white shadow sm:rounded-md">
                    <ul>
                        <install-wizard-connectivity-card
                                v-for="(holdingDevice, index) in devicesOrdered"
                                v-show="shouldShow(holdingDevice)"
                                v-on:device-completed="completeDevice"
                                v-on:device-checkin="checkinDevice"
                                v-on:device-skipped="skipDevice"
                                v-on:device-reset="resetDevice"
                                :holding="holdingDevice"
                                :status="getDeviceComments(holdingDevice.serial)"
                                :key="holdingDevice.serial"
                                :class="index !== 0 ? 'border-t border-gray-200' : ''"
                        >
                        </install-wizard-connectivity-card>
                    </ul>
                </div>
            </template>

            <template #bottom-header>
                Done checking connectivity?
            </template>
            <!--            <template #bottom-button-text></template>-->
        </install-wizard-card>
    </div>
</template>

<script>
    import InstallWizardCard from "./InstallWizardCard";
    import InstallWizardConnectivityCard from "@/components/InstallWizard/InstallWizardConnectivityCard";
    import FloatingInput from "../elements/FloatingInput";

    export default {
        name: "InstallWizardConnectivity",
        props: {
            devices: Array,
            comments: {
                type: [Object, Array]
            },
        },
        data(){
            return {
                search: '',
                completedDevices: [],
                checkedInDevices: [],
                skippedDevices: [],
                gatewayDevices: [],
            }
        },
        created(){
            // Initialize this by setting completed/skipped devices in the array
            _.forOwn(this.comments, (value, serial) => {
                if (this.comments[serial] !== undefined && this.comments[serial]['status'] === 1){
                    this.completedDevices.push(serial);
                } else if(this.comments[serial] !== undefined && this.comments[serial]['status'] === 2){
                    this.skippedDevices.push(serial);
                }
            });
            this.devices.forEach((device, index) => {
                if(this.deviceType(device).includes('Gateway')){
                    this.gatewayDevices.push(device.serial);
                }
            });
        },
        components: {FloatingInput, InstallWizardConnectivityCard, InstallWizardCard},
        methods: {
            shouldShow(device) {
                if (_.isNil(device)) {
                    return false
                }

                let search = this.search.toLowerCase()
                let serial = device.serial
                if (_.isNil(serial)) {
                    return false
                }

                return serial.toLowerCase().indexOf(search) !== -1
            },
            deviceType(device){
                if((device.settings.device_type !== undefined) && device.settings.device_type !== 'Not Installed'){
                    return device.settings.device_type;
                } else {
                    return 'Unknown Device Type';
                }
            },
            getDeviceComments(serial){
                if(this.comments[serial] === undefined){
                    return null;
                } else {
                    return this.comments[serial];
                }
            },
            completeDevice(serial){
                if(!this.completedDevices.includes(serial)){
                    this.completedDevices.push(serial);
                }
            },
            checkinDevice(serial){
                this.checkedInDevices.push(serial);
            },
            skipDevice(serial){
                if(!this.skippedDevices.includes(serial)){
                    this.skippedDevices.push(serial);
                }
            },
            resetDevice(serial){
                if(this.completedDevices.includes(serial)){
                    this.completedDevices = _.without(this.completedDevices, serial);
                }if(this.skippedDevices.includes(serial)){
                    this.skippedDevices = _.without(this.skippedDevices, serial);
                }
            },
            serialIsGateway(serial){
                return (this.gatewayDevices.includes(serial) === true) && !this.serialIsCompleted(serial) && !this.serialIsSkipped(serial);
            },
            serialIsCheckedIn(serial){
                return (this.checkedInDevices.includes(serial) === true) && !this.serialIsCompleted(serial) && !this.serialIsSkipped(serial) && !this.serialIsGateway(serial);
            },
            serialIsCompleted(serial){
                return this.completedDevices.includes(serial);
            },
            serialIsSkipped(serial){
                return this.skippedDevices.includes(serial);
            },
            serialIsNotCheckedIn(serial){
                return !this.serialIsCompleted(serial) && !this.serialIsCheckedIn(serial) && !this.serialIsSkipped(serial) && !this.serialIsGateway(serial);
            }
        },
        computed: {
            devicesNotCheckedIn(){
                return _.filter(this.devices, obj => {
                    return this.serialIsNotCheckedIn(obj.serial);
                });
            },
            devicesGateway(){
                return _.filter(this.devices, obj => {
                    return this.serialIsGateway(obj.serial);
                });
            },
            devicesCheckedIn(){
                return _.filter(this.devices, obj => {
                    return this.serialIsCheckedIn(obj.serial);
                });
            },
            devicesSkipped(){
                return _.filter(this.devices, obj => {
                    return this.serialIsSkipped(obj.serial);
                });
            },
            devicesCompleted(){
                return _.filter(this.devices, obj => {
                    return this.serialIsCompleted(obj.serial);
                });
            },
            devicesOrdered(){
                let sortedArray = [];

                sortedArray = sortedArray.concat(this.devicesGateway);
                sortedArray = sortedArray.concat(this.devicesCheckedIn);
                sortedArray = sortedArray.concat(this.devicesNotCheckedIn);
                sortedArray = sortedArray.concat(this.devicesSkipped);
                sortedArray = sortedArray.concat(this.devicesCompleted);

                return sortedArray;
            }
        }
    }
</script>

<style scoped>

</style>